/**
 * Ventanas temporales del informe.
 *
 * La ventana filtra por FECHA DE CREACION del contacto y de la oportunidad.
 * Es lo que permite que "1 semana" cargue en dos peticiones en vez de barrer
 * las 78.000 fichas de la subcuenta.
 *
 * Consecuencia a tener presente: un lead estancado desde hace tres meses no
 * aparece en la ventana de una semana, porque se creo antes. Las ventanas
 * cortas sirven para vigilar la entrada reciente; para la foto completa de
 * estancados hay que ampliar el rango.
 */

export const RANGES = [
  { id: '7d', label: '1 semana', short: 'Semana', days: 7 },
  { id: '30d', label: '1 mes', short: 'Mes', days: 30 },
  { id: '90d', label: '3 meses', short: '3 meses', days: 90 },
  { id: 'all', label: 'Historico completo', short: 'Total', days: null },
]

export const DEFAULT_RANGE = '7d'

export function rangoPorId(id) {
  return RANGES.find((r) => r.id === id) || RANGES[0]
}

/** Epoch ms desde el que se piden datos. `null` = sin limite. */
export function cutoffDe(id, now = Date.now()) {
  const r = rangoPorId(id)
  return r.days === null ? null : now - r.days * 86400000
}

/**
 * Un rango cubre a otro cuando su ventana es igual o mas amplia: teniendo los
 * datos de 3 meses se puede pintar la semana sin volver a pedir nada.
 */
export function cubre(rangoCargado, rangoPedido) {
  const a = rangoPorId(rangoCargado).days
  const b = rangoPorId(rangoPedido).days
  if (a === null) return true
  if (b === null) return false
  return a >= b
}

/** Rangos que se pueden derivar de los datos ya cargados. */
export function derivablesDe(rangoCargado) {
  return RANGES.filter((r) => cubre(rangoCargado, r.id)).map((r) => r.id)
}
